import {useFormContext} from "react-hook-form";

import {Divider} from "@/components/divider/Divider.tsx";
import {InputField} from "@/components/form/fields/InputField/InputField.tsx";
import {SelectField} from "@/components/form/fields/SelectField/SelectField.tsx";
import {Input} from "@/components/input/Input.tsx";
import {CustomRepeatType} from "@/pages/maintenance/maintenance-create/tabs/general/MaintenanceScheduleGeneralTab.types.ts";
import {CustomRepeatTypeDisplay} from "@/pages/maintenance/maintenance-create/tabs/general/subComponents/CustomRepeatSection/CustomRepeatSection.types.ts";
import {MonthlyRepeatOptions} from "@/pages/maintenance/maintenance-create/tabs/general/subComponents/MonthlyRepeatOptions/MonthlyRepeatOptions.tsx";
import {WeeklyRepeatOptions} from "@/pages/maintenance/maintenance-create/tabs/general/subComponents/WeeklyRepeatOptions/WeeklyRepeatOptions.tsx";

import styles from "./CustomRepeatSection.module.scss";

export const CustomRepeatSection = () => {
  const {watch, register} = useFormContext();
  const customRepeatType: CustomRepeatType = watch("custom_repeat_type") ?? CustomRepeatType.DAY;

  return (
    <div className="d-flex flex-column gap-4">
      <div className="d-flex flex-column gap-1">
        <span className="pulseTextBodySmallBold">Repeat every</span>
        <div className={styles.customRepeatRow}>
          <div className={"d-flex gap-3 w-100"}>
            <InputField
              name="rrule_interval"
              label=""
              className={styles.customIntervalInput}
              input={<Input type="number" min={1} {...register("rrule_interval")} />}
              formSubtextClassName={"text-nowrap"}
            />
            <SelectField
              name="custom_repeat_type"
              label=""
              className={styles.customUnitSelect}
              options={Object.values(CustomRepeatType).map((unit) => ({
                value: unit,
                label: CustomRepeatTypeDisplay[unit],
              }))}
            />
          </div>
        </div>
      </div>

      {(customRepeatType === CustomRepeatType.WEEK || customRepeatType === CustomRepeatType.MONTH) && <Divider />}

      {customRepeatType === CustomRepeatType.WEEK && <WeeklyRepeatOptions />}
      {customRepeatType === CustomRepeatType.MONTH && <MonthlyRepeatOptions />}
    </div>
  );
};
